import { render, staticRenderFns } from "./AtelierPage.vue?vue&type=template&id=2f754bc5&"
import script from "./AtelierPage.vue?vue&type=script&lang=js&"
export * from "./AtelierPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports